<template>
  <div>
    <el-dialog :show-close="false" top="calc((100vh - 800px)/2)" :visible="value" width="860px" :before-close="handleClose">
      <div class="image_box">
        <img class="image" :src="url" alt=""></img>
        <div class="close_btn" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    value: {
      type: Boolean,
      require: true,
    },
    url: {
      type: String,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style lang='scss' scoped>
.image_box {
  width: 860px;
  height: 860px;
  border-radius: 12px;
  position: relative;
  .image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
  }
  .close_btn {
    position: absolute;
    top: 0;
    right: -48px;
    width: 48px;
    height: 48px;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 0px 4px 4px 0px;
    text-align: center;
    line-height: 48px;
    color: #fff;
    font-size: 26px;
    cursor: pointer;
  }
}
::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog__body {
  padding: 0px !important;
  border-radius: 12px;
}
</style>